// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"433":"6457920e","764":"0743bd2f","797":"cb7ede1d"}[chunkId] + ".chunk.css";
};